import { FleekError } from './FleekError';

type ObjectId = {
  id: string;
};

type DomainZoneNotFoundErrorOptions = {
  zone: ObjectId;
  project?: ObjectId;
};

export class DomainZoneNotFoundError extends FleekError<DomainZoneNotFoundErrorOptions> {
  public name = 'DomainZoneNotFoundError';

  toString = () => {
    return 'Domain zone not found.';
  };
}
